<template>
  <div class="breadcrumbs">
    <div class="route">
      <div v-for="(leg, index) in flights.route" :key="index">
        <span v-if="isCurrent(index)" class="on">{{ label(leg, index) }}</span>
        <span v-else-if="isLink(leg, index)">
          <a @click="visit(index)">{{ label(leg, index) }}</a>
        </span>
        <span v-else>{{ label(leg, index) }}</span>
        <span v-if="isArrow(index)" class="arrow">&gt;</span>
      </div>
      <span class="arrow">|</span>
      <div><a @click="edit">Edit Search</a></div>
    </div>
  </div>
</template>

<script setup>
import DateTime from "../utils/datetime";
const { utilDateFlightfox } = DateTime();

// Props
const props = defineProps({
  flights: Object,
  legIndex: Number,
});

// Emits
const emit = defineEmits(["update:isSavedRoute", "update:legIndex"]);

// Methods
const edit = () => {
  emit("update:isSavedRoute", false);
};

const isArrow = index => {
  return index < props.flights.route.length - 1;
};

const isCurrent = index => {
  return props.legIndex == index;
};

const isLink = (leg, index) => {
  if (index < props.legIndex) return true;
  if (leg.ideal.length > 0) return true;
  return false;
};

const label = leg => {
  let toIata = leg.to.iata;
  return utilDateFlightfox(leg.depart) + " · " + leg.from.iata + "-" + toIata;
};

const visit = index => {
  emit("update:legIndex", index);
};
</script>

<style lang="less">
#flights {
  .breadcrumbs {
    align-items: flex-end;
    border-bottom: 0.0625rem solid @border;
    display: flex;
    margin-bottom: 2rem;
    padding-bottom: 0.5rem;

    .route {
      color: @mid;

      div {
        margin-bottom: 0.5rem;

        &:last-child {
          margin-bottom: 0;
        }
      }

      .on {
        color: @dark;
        display: inline-block;
      }
    }

    .arrow {
      display: none;
    }

    .cust {
      margin-left: auto;
    }
  }
}

@media screen and (min-width: 60em) {
  #flights {
    .breadcrumbs {
      .route {
        display: flex;

        div {
          margin-bottom: 0;
        }
      }

      .arrow {
        display: inline-block;
        padding: 0 0.5rem;
      }
    }
  }
}
</style>
